// Подпись итога расчёта по тендеру (Ф5) на экране: итог — без НДС и прочих
// затрат, НДС по ставке на дату расчёта — отдельно и в итог не входит. Саму
// сумму итога показывает `PriceLevelSummary`, здесь — строка под ней.
//
// Чистая логика без React — проверяется node:test (../tenderTotals.test.mjs).
import type { TenderVat } from '@shared/api';

/** Строка под итогом; ставки НДС на дату расчёта нет в справочнике — только
 *  подпись итога. */
export function totalNoteText(vat: TenderVat | null, fmt: (v: number) => string): string {
  const note = 'Итог — без НДС и прочих затрат.';
  if (!vat) return note;
  const rate = String(vat.rate_pct).replace('.', ',');
  return `${note} НДС ${rate}% по ставке на дату расчёта ${vat.on}: ${fmt(vat.amount)} ₽, в итог не входит.`;
}
